"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FreehandFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FreehandFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -1,
    width: 14,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.207 4.127c.39-.39.39-1.024 0-1.415L11.789.292a1 1 0 0 0-1.415 0L8.745 1.924l3.833 3.835 1.629-1.63ZM11.87 6.465 8.038 2.631 1.793 8.879a1 1 0 0 0-.293.708v2.92a.5.5 0 0 0 .5.5h2.918a1 1 0 0 0 .707-.293l6.245-6.249ZM8.694 14.58a4.077 4.077 0 0 1 4.873-.26l.156.104a.5.5 0 1 0 .554-.833l-.155-.103a5.077 5.077 0 0 0-6.069.324l-.373.311a3.775 3.775 0 0 1-5.088-.23l-.238-.24a.5.5 0 1 0-.708.708l.24.239a4.774 4.774 0 0 0 6.434.292l.374-.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FreehandFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FreehandFill;
exports["default"] = _default;